import React, { useState } from "react";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import { pushNotification } from "utils/notifications";
import ThemSuaDongSanPham from "./ChucNang/ThemSuaDongSanPham";
import XoaDongSanPham from "./ChucNang/XoaDongSanPham";

const DongSanPhamTable = ({
  list,
  listHangSanXuat,
  listCauHinhTaiSan,
  RoleThemMoiDongSanPham,
  RoleSuaDongSanPham,
  RoleXoaDongSanPham,
  onSearch,
}) => {
  const [showModel, setShowModel] = useState(false);
  const [showModelXoa, setshowModelXoa] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [delId, setdelId] = useState(0);

  const btn_xoaDongSanPhamClick = (id) => {
    setdelId(id);
    setshowModelXoa(true);
  };
  const btn_SuaDongSanPhamClick = (item) => {
    setEditingItem(item);
    setShowModel(true);
  };
  const btn_themmoiDongSanPhamClick = () => {
    setEditingItem({
      ThongTinGiamTruID: 0,
      ThongTinGiamTruPID: null,
      TenHangHoa: "",
      TenHangSanXuat: "",
      TenDongSanPham: "",
      KeyThongTinGiamTru: "",
      isDel: true,
    });
    setShowModel(true);
  };

  const onSaveThemSuaDongSanPham = async (data) => {
    let success = "";
    let error = "";
    try {
      const res = await ThuocTinhGiamTruApi.addoreditDongSanPham(data);
      const dataResponse = res.data;
      if (res.status === 200) {
        if (data.ThongTinGiamTruID !== 0) {
          success = "Sửa thành công.";
          setShowModel(false);
        } else {
          success = "Thêm mới thành công.";
          setShowModel(false);
        }
        pushNotification(success, "success", "TOP_CENTER", 1000);
        await onSearch();
      } else {
        if (data.ThongTinGiamTruID !== 0) {
          error = "Sửa thất bại: " + dataResponse.Messages;
        } else {
          error = dataResponse.Messages;
          console.log("Error: ", error);
        }
        pushNotification(error, "error", "TOP_CENTER", 1000);
      }
    } catch (err) {
      console.error("Lỗi:", err);
      if (data.ThongTinGiamTruID !== 0) {
        error = "Lỗi khi gọi Api Sửa!";
      } else {
        error = "Lỗi khi gọi Api Thêm mới!";
      }
      pushNotification(error, "error", "TOP_CENTER", 1000);
    }
  };
  const onDelete = async (id) => {
    try {
      await ThuocTinhGiamTruApi.deleteDongSanPham({ id });
      pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
      setshowModelXoa(false);
      await onSearch();
    } catch (err) {
      console.error("Lỗi khi xóa:", err);
      pushNotification(
        "Không thể xóa. Vui lòng thử lại!",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  };

  const [dataSearch, setDataSearch] = useState({
    ThongTinGiamTruID: "",
  });

  const onChangeData = (field) => (event) => {
    const value = event?.target?.value ?? "";
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const filteredList = list.filter((item) => {
    // Nếu chưa chọn gì => hiển thị tất cả
    if (!dataSearch.ThongTinGiamTruID) return true;
    // So sánh ID của hãng sản xuất và PID của dòng sản phẩm
    return item.ThongTinGiamTruPID === Number(dataSearch.ThongTinGiamTruID);
  });

  return (
    <>
      <div className="Left808x200 Table-main-new css-table-ds">
        <div
          className="card-body card-body-v2"
          style={{
            marginBottom: "10px",
            maxHeight: "54px",
            display: RoleThemMoiDongSanPham ? "block" : "none",
          }}
        >
          <div className="search-new">
            <div className="input-sm-new" style={{ width: "12%" }}>
              <select
                id="ThongTinGiamTruID"
                name="ThongTinGiamTruID"
                value={dataSearch.ThongTinGiamTruID}
                onChange={onChangeData("ThongTinGiamTruID")}
                className="form-control input-sm"
              >
                <option value="">Tất cả</option>
                {listHangSanXuat &&
                  listHangSanXuat.map((HangSanXuat, index) => (
                    <option key={index} value={HangSanXuat.ThongTinGiamTruID}>
                      {HangSanXuat.TenHangSanXuat}
                    </option>
                  ))}
              </select>
            </div>
            <div className="input-sm-new" style={{ width: "12%" }}>
              <button
                className="btn btn-sm"
                onClick={btn_themmoiDongSanPhamClick}
                style={{
                  minWidth: "100%",
                  color: "#00B69B",
                  border: "2px solid #00B69B",
                  backgroundColor: "white",
                }}
              >
                <img
                  src="/app-assets/images/icon-them-moi-cam-do.png"
                  class="icon-button-v2"
                />
                <span style={{ color: "" }}>Thêm mới</span>
              </button>
            </div>
          </div>
        </div>
        <div className="table-mobile sticky-table-bh2 table-mobile-hover">
          <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
            <div className="table-headers">
              <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                <p className="color-do-bold">
                  STT
                  <br />[{filteredList.length === 0 ? 0 : filteredList.length}]
                </p>
              </div>
              <div className="custom-table-header flex-basis-15 flex-basis-15-sm r">
                <p>Loại tài sản</p>
              </div>
              <div className="custom-table-header flex-basis-15 flex-basis-15-sm ">
                <p>Hãng sản xuất</p>
              </div>
              <div className="custom-table-header flex-basis-15 flex-basis-15-sm ">
                <p>Dòng sản phẩm</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                <p>Chức năng</p>
              </div>
            </div>
            <div className="custom-table-body">
              {!filteredList ||
                (filteredList.length === 0 && (
                 <div
            className="custom-table-cell-v2 text-center red"
            style={{ width: "100%" }}
          >
            Không có dữ liệu
          </div>
                ))}
                {filteredList &&
                (filteredList.length !== 0 && (
                  <DongSanPhamTableRows
                    list={filteredList}
                    RoleSuaDongSanPham={RoleSuaDongSanPham}
                    RoleXoaDongSanPham={RoleXoaDongSanPham}
                    btn_SuaDongSanPhamClick={btn_SuaDongSanPhamClick}
                    btn_xoaDongSanPhamClick={btn_xoaDongSanPhamClick}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      {showModel && (
        <ThemSuaDongSanPham
          onClose={() => setShowModel(false)}
          onSave={onSaveThemSuaDongSanPham}
          data={editingItem}
          listCauHinhTaiSan={listCauHinhTaiSan}
          listHangSanXuat={listHangSanXuat}
        />
      )}
      {showModelXoa && (
        <XoaDongSanPham
          ThongTinGiamTruID={delId}
          onClose={() => setshowModelXoa(false)}
          onDelete={onDelete}
        />
      )}
    </>
  );
};

const DongSanPhamTableRows = ({
  list,
  RoleSuaDongSanPham,
  RoleXoaDongSanPham,
  btn_SuaDongSanPhamClick,
  btn_xoaDongSanPhamClick,
}) => {
  return list.map((item, index) => {
    const isDel = item.isDel;
    return (
      <div
        className="custom-table-row"
        key={"item" + index}
        style={{ minHeight: "62px" }}
      >
        <div className="custom-table-cell-v2 flex-basis-5 flex-basis-5-sm disk-mobile ">
          <span className="mobile-column-name color7-bold">STT</span>
          <div className="center-wrapper">
            <p className="text-center color7">{index + 1}</p>
          </div>
        </div>
        <div className="custom-table-cell-v2 flex-basis-15 flex-basis-15-sm ">
          <span className="mobile-column-name color7-bold">Loại tài sản</span>
          <div className="center-wrapper color7" title={item.TenHangSanXuat}>
            {item.TenHangHoa}
          </div>
        </div>
        <div className="custom-table-cell-v2  flex-basis-15 flex-basis-15-sm ">
          <span className="mobile-column-name color7-bold">Hãng sản xuất</span>
          <div className="center-wrapper color7" title={item.TenHangSanXuat}>
            {item.TenHangSanXuat}
          </div>
        </div>
        <div className="custom-table-cell-v2  flex-basis-15 flex-basis-15-sm ">
          <span className="mobile-column-name color7-bold">Dòng sản phẩm</span>
          <div className="center-wrapper color7" title={item.TenDongSanPham}>
            {item.TenDongSanPham}
          </div>
        </div>
        <div className="custom-table-cell-v2 flex-basis-10 flex-basis-10-sm">
          <span className="mobile-column-name color7-bold">Chức năng</span>
          <div className="center-wrapper">
            {RoleSuaDongSanPham && (
              <>
                <div className="iconTableMorman">
                  <a title="Sửa" onClick={() => btn_SuaDongSanPhamClick(item)}>
                    <img src="/app-assets/images/icon-edit-v2.png" />
                  </a>
                </div>
              </>
            )}
            {RoleXoaDongSanPham && item.isDel && (
              <>
                <div className="iconTableMorman">
                  <a
                    title="Xóa"
                    onClick={() =>
                      btn_xoaDongSanPhamClick(item.ThongTinGiamTruID)
                    }
                  >
                    <img src="/app-assets/images/icon-xoa-v2.png" />
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  });
};
export default DongSanPhamTable;
